// extracted by mini-css-extract-plugin
module.exports = {"containers":"style_containers__2qLMs","lorem":"style_lorem__1fDAC","fle":"style_fle__zRML_","fiveStar":"style_fiveStar__3pvfy","title":"style_title__26AAD"};